import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-drivemax',
  templateUrl: './page-drivemax.component.html',
  styleUrls: ['./page-drivemax.component.css']
})
export class PageDrivemaxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
